import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getMatches } from "../../services/matchService";
import { getLeagues } from "../../services/leagueService";
import { getMatchQuestions } from "../../services/matchQuestionService";
import { addASectionResult } from "../../services/asectionResultService";

export const AddAsectionsQuestionsResultLayer = () => {
  const [leagues, setLeagues] = useState([]);
  const [matches, setMatches] = useState([]);
  const [questions, setQuestions] = useState([]);

  const [leagueId, setLeagueId] = useState("");
  const [matchId, setMatchId] = useState("");

  const [filteredMatches, setFilteredMatches] = useState([]);
  const [answers, setAnswers] = useState({});

  const [loading, setLoading] = useState(false);

  /* ================= LOAD DATA ================= */
  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      const [leagueRes, matchRes] = await Promise.all([
        getLeagues(),
        getMatches(),
      ]);

      if (leagueRes?.status) setLeagues(leagueRes.data || []);
      if (matchRes?.status) setMatches(matchRes.data || []);
    } catch {
      toast.error("Failed to load data");
    }
  };

  /* ================= FILTER MATCH BY LEAGUE ================= */
  useEffect(() => {
    if (!leagueId) {
      setFilteredMatches([]);
      setMatchId("");
      return;
    }

    const list = matches.filter(
      (m) => String(m.league_id) === String(leagueId)
    );

    setFilteredMatches(list);
    setMatchId("");
    setQuestions([]);
    setAnswers({});
  }, [leagueId, matches]);

  /* ================= LOAD QUESTIONS ================= */
  useEffect(() => {
    if (!matchId) {
      setQuestions([]);
      setAnswers({});
      return;
    }

    loadQuestions(matchId);
  }, [matchId]);

  const loadQuestions = async (id) => {
    try {
      const res = await getMatchQuestions(id);

      if (res?.status && Array.isArray(res.data)) {
        setQuestions(res.data);
      } else {
        setQuestions([]);
      }
    } catch {
      toast.error("Failed to load questions");
      setQuestions([]);
    }
  };

  const handleAnswerChange = (questionId, value) => {
    setAnswers({
      ...answers,
      [questionId]: value,
    });
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async () => {
    if (!leagueId || !matchId) {
      toast.error("League & Match required");
      return;
    }

    const settlements = questions.map((q) => ({
      question_id: q.id,
      match_id: Number(matchId),
      winning_option: answers[q.id] || "",
    }));

    if (settlements.some((s) => !s.winning_option)) {
      toast.error("Select winning option for all questions");
      return;
    }

    setLoading(true);

    try {
      const res = await addASectionResult({
        league_id: Number(leagueId),
        settlements,
      });

      if (res?.status) {
        toast.success("Results submitted successfully");

        setLeagueId("");
        setMatchId("");
        setQuestions([]);
        setAnswers({});
      } else {
        toast.error(res?.message || "Failed");
      }
    } catch {
      toast.error("Server error");
    }

    setLoading(false);
  };

  return (
    <div className="container-fluid mt-4">
      <div style={{padding:"30px"}} className="card shadow-sm ">

        <h5 className="mb-4">Declare Section A Results</h5>

        {/* LEAGUE */}
        <div className="mb-3 ">
          <label className="form-label">League</label>
          <select
            className="form-select"
            value={leagueId}
            onChange={(e) => setLeagueId(e.target.value)}
          >
            <option value="">Select League</option>
            {leagues.map((l) => (
              <option key={l.id} value={l.id}>
                {l.league_name}
              </option>
            ))}
          </select>
        </div>

        {/* MATCH */}
        <div className="mb-4">
          <label className="form-label">Match</label>
          <select
            className="form-select"
            value={matchId}
            onChange={(e) => setMatchId(e.target.value)}
            disabled={!leagueId}
          >
            <option value="">Select Match</option>
            {filteredMatches.map((m) => (
              <option key={m.id} value={m.id}>
                {m.team_a} vs {m.team_b}
              </option>
            ))}
          </select>
        </div>

        {/* QUESTIONS TABLE */}
        {questions.length > 0 && (
          <>
            <div className="table-responsive">
              <table className="table table-bordered text-center align-middle">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Question</th>
                    <th>A</th>
                    <th>B</th>
                  </tr>
                </thead>
                <tbody>
                  {questions.map((q, index) => (
                    <tr key={q.id}>
                      <td>{index + 1}</td>
                      <td className="text-start">
                        {q.question_title}
                      </td>
                      <td>
                        <button
                          className={`btn btn-sm ${
                            answers[q.id] === "A"
                              ? "btn-success"
                              : "btn-outline-success"
                          }`}
                          onClick={() =>
                            handleAnswerChange(q.id, "A")
                          }
                        >
                          A
                        </button>
                      </td>
                      <td>
                        <button
                          className={`btn btn-sm ${
                            answers[q.id] === "B"
                              ? "btn-primary"
                              : "btn-outline-primary"
                          }`}
                          onClick={() =>
                            handleAnswerChange(q.id, "B")
                          }
                        >
                          B
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button
              className="btn btn-dark w-100 mt-3"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit All Results"}
            </button>
          </>
        )}

      </div>
    </div>
  );
};